declare var swal: any;
import { Component, OnInit, Input } from '@angular/core';
//import * as Chartist from 'chartist';
//import { ChartType, ChartEvent } from "ng-chartist/dist/chartist.component";
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { IsSessionExistsRequest } from '../../../../../../../src/app/ncs/models/login/loginrequestmodel';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginService } from '../../../../../../../src/app/ncs/services/login.service';
import { ApiResponseModel } from '../../../../../../../src/app/ncs/models/api_response_model';
//import { Observable } from 'rxjs/Observable';
//import { Subscription } from 'rxjs/Subscription';
import { ActorDashBoardProfileSummaryInfoRequest, DashBoardProfileSummaryController } from '../../../../../../../src/app/ncs/models/profileinfo/profileinfo.model';
import { HCPService } from '../../../../../../../src/app/ncs/services/hcp.service';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
//import { NgbScheduleAssistantModal } from './scheduleassistant/scheduleassistant.modal';

declare var require: any;


import * as alertFunctions from '../../../../../../../src/app/shared/data/sweet-alerts';
import { Observable, Subscription } from 'rxjs';
import { routerTransition } from '../../../../animations/router.animations';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { PatientInfoByFormattedCodeRequest, PatientInfoByFormattedCodeController, TreatmentCyclesController, TreatmentCyclesRequest, GenericProcPostRequest, S_Methods, GetTreamtmentCyclesListRequest, DeleteTreatmentCycleRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { ActorService } from '../../../../../../../src/app/ncs/services/actor.service';
import { NgbSearchPatientModal } from '../../follow up/counsellingregistry/modal/searchpatient.modal';
import { NgbNewCycleModal } from './newcycle.modal';
import { NgbUpdateCycleStatusModal } from './updatecyclestatus.modal';
import { NGXToastrService } from '../../../../../../../src/app/shared/services/toastr.service';
import { NgbEditCycleModal } from '../TreatmentCycle/editcycle.modal';
import { NgbNewEpisodeModal } from './newepisode.modal';
//import { NgbAddNewPatient } from './modal/addnewpatient.modal';





@Component({
  selector: 'eggdonordashboard',
  templateUrl: './eggdonordashboard.component.html',
  styleUrls: [
    './eggdonordashboard.component.scss']
  , animations: [routerTransition()]
})

export class EggDonorDashboardComponent implements OnInit {
  OnGoBack() {
    //alert("I cam bak");
    this.ShowList = true;
  }

  GetActorIdentitiesController(): any {
    throw new Error("Method not implemented.");
  }
  public ShowListView: boolean = false;
  public ActorCode: number = 0;
  public FormattedCode: number = 0;
  public isNew: boolean = false;
  public isEdit: boolean = false;
  public IsExpand: boolean = true;
  public Showarrow: boolean = false;
  public Showrow: boolean = true;
  public searchValue: string;
  public ShowPatientDetails: boolean = false;
  public isRequesting: boolean = false;
  CurrentIsSessionExistsRequest: IsSessionExistsRequest;
  public ApiResData: ApiResponseModel;

  CurrentActorDashBoardProfileSummaryInfoRequest: ActorDashBoardProfileSummaryInfoRequest;
  CurrentDashBoardProfileSummaryController: DashBoardProfileSummaryController;
  CurrentTreatmentCyclesController: TreatmentCyclesController[];
  CurrentTreatmentCyclesRequest: TreatmentCyclesRequest;
  LoadPatients() {
    this.CurrentTreatmentCyclesRequest = new TreatmentCyclesRequest();
    //this.CurrentTreatmentCyclesRequest.FormattedCode = "GG1O/577";
    this.CurrentTreatmentCyclesRequest.Branch = 0;
    this.CurrentTreatmentCyclesRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesRequest.ToDate = new Date();
    //this.CurrentTreatmentCyclesRequest.CycleCode = 0;
    //this.CurrentTreatmentCyclesRequest.From = 0;
    //this.CurrentTreatmentCyclesRequest.Status = "";
    this.CurrentTreatmentCyclesRequest.SearchText = "";
    this.CurrentTreatmentCyclesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetTreatmentCyclesController();
  }
  RefreshPatients(st: string) {
      this.CurrentTreatmentCyclesRequest = new TreatmentCyclesRequest();
    // this.CurrentTreatmentCyclesRequest.FormattedCode = "";
    this.CurrentTreatmentCyclesRequest.Branch = 0;
    this.CurrentTreatmentCyclesRequest.ConditionalOperator = 10;
    this.CurrentTreatmentCyclesRequest.FromDate = new Date();
    this.CurrentTreatmentCyclesRequest.ToDate = new Date();
    //this.CurrentTreatmentCyclesRequest.IsToday = true;
    //this.CurrentTreatmentCyclesRequest.IsDuration = false;
    this.CurrentTreatmentCyclesRequest.SearchText = st;

    this.CurrentTreatmentCyclesRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this._GetTreatmentCyclesController();
  }
  _GetTreatmentCyclesController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesController(this.CurrentTreatmentCyclesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //this.CurrentTreatmentCyclesController = null;
          this.CurrentTreatmentCyclesController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  GetTreatmentCyclesController() {
    this.StartRefreshing();


    this.actorservice.GetTreatmentCyclesController(this.CurrentTreatmentCyclesRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentTreatmentCyclesController = this.ApiResData.Result;
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentTreatmentCyclesListController: TreatmentCyclesController[];
  LoadCyclesGeneric() {
    var getReq = new GetTreamtmentCyclesListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101048;
    getReq.Branch = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SearchText = "";
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101048;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentTreatmentCyclesController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }
  RefreshLoadCyclesGeneric(st: string) {
    var getReq = new GetTreamtmentCyclesListRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    getReq.ConditionalOperator = 101048;
    getReq.Branch = 0;
    getReq.FromDate = new Date();
    getReq.ToDate = new Date();
    getReq.SearchText = st;
    getReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(getReq);
    gReq.ConditionalOperator = 101048;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.GetGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          var data: string = this.ApiResData.Result.join("");
          //alert(data);
          this.CurrentTreatmentCyclesController = JSON.parse(data);
          if (this.ApiResData.Result[0].length > 0) {
            //this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
          }
          else {
            // alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  sub: Subscription;
  constructor(private router: Router,
    private loaderService: SpinnerService,
    private hcpservice: HCPService,
    private actorservice: ActorService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private loginservice: LoginService,
    private tosterservice: NGXToastrService) { }

  ngOnInit() {

    this.CurrentActorDashBoardProfileSummaryInfoRequest = new ActorDashBoardProfileSummaryInfoRequest();
    this.CurrentDashBoardProfileSummaryController = new DashBoardProfileSummaryController();


    this.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    this.isNew = true;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.ActorCode = this.ActorCode;
    this.CurrentActorDashBoardProfileSummaryInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDashBoardProfileSummaryController();
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.SelectedPatient.FormattedCode;
    //this.LoadPatients();
    this.LoadCyclesGeneric();
    //this.GetPatientInfoByFormattedCodeController();

  }

  DisplayStyle(Type: string) {
    if (Type == 'List') {
      this.ShowListView = true;      
    }
    else if (Type == 'Card') {
      this.ShowListView = false;
    }
  }

  ShowList: boolean = true;

  GetDashBoardProfileSummaryController() {
    //  console.log(this.CurrentActorProfileRequest.SendApiRequestModel.xAuthGenKEY);
    this.StartRefreshing();
    this.hcpservice.GetDashBoardProfileSummaryController(this.CurrentActorDashBoardProfileSummaryInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //  console.log('GetActorProfileController');
          this.CurrentDashBoardProfileSummaryController = this.ApiResData.Result[0];
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }
  EditCycleDetails(l) {
    const modalRef = this.modalService.open(NgbEditCycleModal,
      {
        centered: true,
        size: "lg",
        keyboard: false

      })
    modalRef.componentInstance.DisplayName = l.DisplayName;
    modalRef.componentInstance.Code = l.Code; 
    modalRef.componentInstance.Gender = l.Gender;
    modalRef.componentInstance.Age = l.Age;
    modalRef.componentInstance.PatientRegNo = l.PatientRegNo;
    modalRef.componentInstance.CycleType = l.CycleType;
    modalRef.componentInstance.ProtocolName = l.ProtocolName;
    modalRef.componentInstance.TCModelName = l.TCModelName;
    modalRef.componentInstance.ProtocolStartDate = l.ProtocolStartDate;
    modalRef.componentInstance.ProtocolEndDate = l.ProtocolEndDate;
    modalRef.componentInstance.LMP = l.LMP;
    modalRef.componentInstance.CycleNo = l.CycleNo;
    modalRef.componentInstance.Remarks = l.Remarks;
    modalRef.componentInstance.InfertilityType = l.InfertilityType;
    modalRef.result.then(x => { this.LoadCyclesGeneric() })
  }
  DeleteCycle(l) {
    swal({
      title: 'Please Confirm..',
      text: "You won't be able to revert deletion of cycle after this!!",
      type: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#0CC27E',
      cancelButtonColor: '#FF586B',
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonClass: 'btn btn-success btn-raised mr-5',
      cancelButtonClass: 'btn btn-danger btn-raised',
      allowOutsideClick: false,
      buttonsStyling: false
    }).then(() => {

      this.DeleteTreatmentCycle(l);

      //this.DeleteActorIdentitiesMedicine(l);
      // alertFunctions.AlertParam('Delete Successfully...!');

    }, function (dismiss) {
      // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
      if (dismiss === 'cancel') {
        swal(
          'Cancelled',
          'Delete Operation Cancelled :)',
          'error'
        )
      }
    })

  }
  DeleteTreatmentCycle(l) {
    var saveReq = new DeleteTreatmentCycleRequest();
    var gReq: GenericProcPostRequest = new GenericProcPostRequest();
    saveReq.ConditionalOperator = 80120;
    saveReq.ActorCode = AppData.Instance().UserLoginDetails.ActorCode;
    saveReq.UserName = AppData.Instance().UserLoginDetails.UserName;
    saveReq.CycleCode = l.Code;
    saveReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    var str = JSON.stringify(saveReq);
    gReq.ConditionalOperator = 80120;
    gReq.QueryData = str;
    gReq.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.actorservice.Save<GenericProcPostRequest>(
      gReq, S_Methods.SaveGenericPost)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          if (this.ApiResData.Result[0].length > 0) {
            this.tosterservice.ToasterSuccessAlertParam('Saved Successfully.....!');
            this.stopRefreshing();
            this.LoadCyclesGeneric();
            //this.activeModal.close();
          }
          else {
            alertFunctions.AlertParam("Invalid Operation...!");
            this.stopRefreshing();
          }
        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {
            alert(this.ApiResData.ErrorData);
          }
          else {
            this.stopRefreshing();
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },
        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
          else {
            alertFunctions.AlertParamEr(error);

            this.stopRefreshing();
          }
        }
      );
  }

  BackToProfile() {
    this.ShowList = true;
    this.ShowPatientDetails = false;
    this.Showarrow = false;
  }


  clearData() {
    this.isNew = true;
    this.ShowList = false;

  }
  ExpandData() {
    if (this.IsExpand === true) {
      this.IsExpand = false;
    }
    else {
      this.IsExpand = true;
    }
  }

  //AddNewPatient() {

  //  const modalRef = this.modalService.open(NgbAddNewPatient,
  //    {
  //      centered: true,
  //      size: "lg",
  //      backdrop: 'static',
  //      keyboard: false
  //    })
  //  modalRef.componentInstance.ActorCode = this.ActorCode;
  //  //modalRef.componentInstance.ActorCode = this.ActorCode;
  //  modalRef.result.then(x => { this.GetPatientInfoByFormattedCodeController() })

  //}
  CancelNewOperation() {

    this.ShowList = true;
  }

  ///////////
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }


  gotoprofile() {
    this.router.navigate(['testnurse/profile']);

  }

  //SelectedPatient: PatientInfoByFormattedCodeController;
  //ViewPatientDetails(objCategory: any) {
  //  var patient: PatientInfoByFormattedCodeController = objCategory;

  //  if (patient != null) {



  //    this.ShowPatientDetails = true;
  //    this.ShowList = false;
  //    this.SelectedPatient = patient;
  //    this.Showarrow = true;
  //    this.Showrow = false;
  //    //this.LoadPatientdetails()

  //  }
  //  else {
  //    this.ShowPatientDetails = false;
  //  }
  //}
  //SelectedPatientDetailsController: PatientInfoByFormattedCodeController;
  //SelectedPatientDetailsRequest: PatientInfoByFormattedCodeRequest;
  //LoadPatientdetails() {


  //  this.SelectedPatientDetailsRequest = new PatientInfoByFormattedCodeRequest();

  //  this.SelectedPatientDetailsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
  //  this.SelectedPatientDetailsRequest.FormattedCode = this.SelectedPatient.ActorCode.toString();// AppData.Instance().UserLoginDetails.FacilityActorCode;
  //  this.GetPatientInfoByFormattedCodeController();
  //}
  SelectedPatient: TreatmentCyclesController;
  ViewPatientDetails(objCategory: any) {
    var patient: TreatmentCyclesController = objCategory;
    if (patient != null) {
      this.SelectedPatient = null;
      this.SelectedPatient = patient;
      this.ShowList = false;
      this.ShowPatientDetails = true;
      //this.ShowList = false;
      this.Showarrow = false;
      this.Showrow = false;
      //this.ShowData = false;

    }
    else {

    }

  }
  SearchPatient() {
    const modalRef = this.modalService.open(NgbSearchPatientModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })

    modalRef.result.then((val: string) => {
      //alert(val);
      const modalRef = this.modalService.open(NgbNewEpisodeModal,
        {
          centered: true,
          size: 'lg',
          backdrop: 'static',
          keyboard: false
        })
      modalRef.componentInstance.FormattedCode = val;
      //modalRef.componentInstance.PatientName = val;
      //modalRef.componentInstance.PatientRegistrationNumber = val;
      modalRef.result.then(x => { this.LoadCyclesGeneric() })
    });

  }
  UpdateStatus(l: TreatmentCyclesController) {
    const modalRef = this.modalService.open(NgbUpdateCycleStatusModal,
      {
        centered: true,
        size: 'lg',
        backdrop: 'static',
        keyboard: false
      })
    modalRef.componentInstance.FormattedCode = l.PatientRegNo;
    modalRef.componentInstance.TreatmentCycleCode = l.Code;
  }
  criteriaChange(value: string) {
    //this.RefreshPatients(value);
    this.RefreshLoadCyclesGeneric(value);

  }
  ClearInput() {
    this.searchValue = '';
    // this.searchValue = null;
    //var searchtext = '';
    //this.RefreshPatients(this.searchValue);
    this.RefreshLoadCyclesGeneric(this.searchValue);
  }
}
